<style lang="less">
.pdf-export{
  .markdown-body h1{
    margin-top:0 !important;
  }
}
</style>
<template>
    <div style="height:100%;overflow:hidden;">
      <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
        <div class="flex-wrap split5">
            <!-- <Select v-model="project_id" filterable style="width:300px" placeholder="选择项目" @on-change="cached=false;getProjectData()">
          <template v-for="pr in projects">
          <Option
            :value="pr.id"
            :key="pr.id"
            :label="pr.name"
          >
          {{ pr.name }}
            <Tag>{{ pr.finished?'已完成':'进行中' }}</Tag>
            <Tag>{{ pr.group}}</Tag>
          </Option>
        </template>
        </Select> -->
        选择人员
        <Select v-model="uid" style="width:140px;margin-right:10px;" placeholder="选择人员"
        filterable @on-change="getData()">
          <Option
            v-for="p in users"
            :value="p.key"
            :key="p.key"
          >
          {{ p.name }}
          </Option>
        </Select>
        <block v-if="person_projects.length > 1" style="white-space:nowrap;">
        选择项目({{ person_projects.length }})
        <Select v-model="selected_projects" multiple style="" placeholder="选择项目"
        filterable @on-change="filterData()">
          <Option
            v-for="p in person_projects"
            :value="p"
            :key="p"
          >
          {{ p }}
          </Option>
        </Select>
      </block>

        </div>
        <Button @click="exportPDF">导出pdf</Button>

      </div>
      <div class="flex-wrap flex-between" style="height:calc(100% - 50px);border-top:1px solid var(--border);position:relative;padding:10px;width:100%;overflow:hidden;align-items:stretch">
        <div style="border:1px dashed var(--border);height:calc(100%);flex-shrink:1;flex-grow:1;">
          <Input
            type="textarea"
            v-model="userText"
            :rows="8"
            style="width:100%;display:block"
            placeholder="请输入您的需求，尽可能详细，比如：帮我设计一个监理用表:瓶装液化气安全检查"
          />
          <div class="flex-wrap flex-between">
            <div>  <Button
            style="margin:10px 0;"
            @click="getData">获取数据</Button>
            <i-switch style="margin-left:10px;" size="small" v-model="onlySelf" @on-change="filterData" /> 只展示本人工作 ({{ onlySelf ? '是' : '否' }})
            <i-switch style="margin-left:10px;" size="small" v-model="extractForm" @on-change="filterData" /> 提取表格 ({{ extractForm ? '是' : '否' }})
            <i-switch style="margin-left:10px;" size="small" v-model="onlyQuestion" @on-change="filterData" /> 隐藏合规项 ({{ onlyQuestion ? '是' : '否' }}) <span style="color:var(--warning)">*缩短文本长度</span>
           <span style="margin-left:10px;color:var(--primary)">文本长度:{{ aiText.length }}</span></div>
           <div class="flex-wrap">
            <Button @click="CopyToClip" type="error">复制</Button>
            <!-- <Button
            type="primary"
            @click="CreateByAI"
            :loading="ai_executings">{{ai_executings?'正在努力生成,请耐心等待20-30s...':(cached?'查看报告':'生成报告')}}</Button>
            <Button
            style="margin:10px"
            v-if="cached"
            @click="CreateByAI(true)"
            :loading="ai_executings">重新生成</Button> -->
          </div>
          </div>
          <div class="flex-wrap split5" style="height:40px;padding:0 10px">
            跟踪记录
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
           <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
           <Button @click="prevWeek">上一周</Button>
           <Button @click="nextWeek">下一周</Button>
           <Button @click="filterData">清理跟踪记录</Button>
           </div>


          <div class="flex-wrap flex-center pdf-export" style="height:calc(100% - 270px);background:#fff;position:relative;overflow-y:auto;padding:10px;">
            <Input
            type="textarea"
            v-model="aiText"
            :rows="23"
            style="width:100%;height:100%;display:block"
            placeholder="请输入您的需求，尽可能详细，比如：帮我设计一个监理用表:瓶装液化气安全检查"
          />
          </div>
        </div>
        <div class="pdf-export" style="width:900px;height:100%;flex-shrink:0;background:#fff;border:1px solid var(--border);overflow-y:auto;margin-left:10px;padding:20px 40px;height:100%;">
          <div class="flex-wrap" style="width:100%;flex-wrap:wrap;">

            <BaseImageList :files="images" />
          </div>
          <div v-for="(file,index) in images" :key="index">
            图片{{index+1}}:
            <a :href="file" target="_blank">{{file}}</a>
          </div>
          <div v-for="(file,index) in files" :key="index">
            附件{{index+1}}:
            <a :href="file" target="_blank">{{file}}</a>
          </div>
          <BaseMarkdownView  ref="content" :value="result" />
        </div>
      </div>
      <BaseLoadingModal v-model="loading" title="正在提取数据" />
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import {extractAttachments, deepCleanTask, renderEFormMap} from '@/components/ai/clean';

export default {
  data() {
    return {
      run: {},
      steps: [],
      messages: {},
      models: [],
      aiText: '',
      model: 'douyin',
      data: '',
      uid: 'wangqw8001',
      task: {},
      loading: false,
      users: [],
      extractForm: false,
      onlyQuestion: false,
      images: [],
      files: [],
      selected_projects: [],
      userText: '',
      onlySelf: false,
      tracking_startDate: moment().startOf('week').subtract(1, 'week').format('YYYY/MM/DD'),
      tracking_endDate: moment().endOf('week').subtract(1, 'week').format('YYYY/MM/DD'),
      ai_executings: false,
      result: '考虑到接口费用实验成本太高，大家可以把数据拿到AI应用程序里测试，待确定好应用提示词再做到系统里。点击左侧复制按钮可以复制数据内容。加上自己设定的提示词进行多维度的分析实验。',
      tasks: [],
      task_id: '',
      person_projects: [],
      selected_projects: [],
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'recent',
      cached: false,
      views: [
        {
          key: 'all',
          name: '全部工作',
        }, {
          key: 'finished',
          name: '已完工作',
        }, {
          key: 'allToDo',
          name: '未完工作',
        }, {
          key: 'recent',
          name: '近期工作',
        }, {
          key: 'myTodo',
          name: '我的待办',
        }, {
          key: 'today',
          name: '今日动态',
        }, {
          key: 'yestoday',
          name: '昨日动态',
        }, {
          key: 'theDayBeforeYestoday',
          name: '前日动态',
        }, {
          key: 'aboutMe',
          name: '我的工作',
        }, {
          key: 'alert',
          name: '预警工作',
        }, {
          key: 'nonActivation',
          name: '尚未启动',
        }],
    };
  },

  mounted() {
    setTimeout(()=>{
      this.getUsers();
      this.getData();
    }, 500);
  },
  methods: {

    getData() {
      this.loading = true;
      this.$api.post('logined_zzl/get_tracking_data', {uid: this.uid,
        started_at: this.tracking_startDate,
        ended_at: this.tracking_endDate,
      }).then((res)=>{
        const tasks = res.data.data;
        this.tasks = tasks;
        this.filterData();
        this.loading = false;
      }).catch((e)=>{
        this.loading = false;
      });
    },
    filterData() {
      const tasks = this.tasks;
      const groupmap = {};
      tasks.forEach((t)=>{
        if (!t.projectName) {
          return;
        }
        if (groupmap[t.projectName]) {
          groupmap[t.projectName].push(t);
        } else {
          groupmap[t.projectName] = [t];
        }
      });
      let result = '';
      const eformmap = {};
      this.person_projects = Object.keys(groupmap);
      let projects = this.person_projects;
      if (this.selected_projects.length > 0) {
        projects = projects.filter((p)=>this.selected_projects.includes(p));
      }
      projects.forEach((p)=>{
        result += '======== 项目名称:' + p + '========\n';
        groupmap[p].forEach((t)=>{
          result += deepCleanTask(t, this.tracking_startDate, this.tracking_endDate, this.onlySelf?this.uid:null, this.extractForm?eformmap:null, this.onlyQuestion) + '\n';
        });
      });

      const formstrs = renderEFormMap(eformmap);


      this.aiText = result;
      const user = this.users.find((u)=>u.key == this.uid);
      this.userText = `以下是[${user.name}]一周的工作任务数据，请进行统计、分析和简要评价后，生成工作周报[${moment(this.tracking_startDate).format('YYYY/MM/DD')}]-[${moment(this.tracking_endDate).format('YYYY/MM/DD')}]。工作周报内容分为三部分，第一部分是工作统计分析；第二部分是工作记录关键数据分析，这部分需列表展示；第三部分是工作任务执行评价。注意如果任务包含多项目/事业部的数据，注意区分;${this.onlyQuestion?'注意检查表提供的数据的合规项已隐藏，只显示异常项目':''}`;
      this.aiText = formstrs + '\n' +this.aiText;
      const {images, files, text} = extractAttachments(this.aiText);
      this.images =images;
      this.files =files;
      this.aiText = text;
    },
    prevWeek() {
      this.tracking_startDate = moment(this.tracking_startDate).startOf('week').subtract(1, 'week').format('YYYY/MM/DD');
      this.tracking_endDate = moment(this.tracking_startDate).endOf('week').format('YYYY/MM/DD');
      this.getData();
    },
    nextWeek() {
      this.tracking_startDate = moment(this.tracking_startDate).startOf('week').add(1, 'week').format('YYYY/MM/DD');
      this.tracking_endDate = moment(this.tracking_startDate).endOf('week').format('YYYY/MM/DD');
      this.getData();
    },
    getModels() {
      this.$api.get('ai/parse/models').then((res)=>{
        this.models = res.data.data;
      });
    },
    getProjects() {
      this.$api.get('logined_zzl/projects').then((res)=>{
        this.projects = res.data.data;
      });
    },
    getUsers() {
      this.$api.get('logined_zzl/users').then((res)=>{
        this.users = res.data.data;
      });
    },
    exportPDF() {
      const project = this.projects.find((p)=>p.id == this.project_id);
      const opt = {
        margin: 1,
        filename: `${project.name}_${this.view}_${moment().format('YYYYMMDD')}.pdf`,
        image: {type: 'jpeg', quality: 0.98},
        html2canvas: {scale: 2}, // 提高清晰度
        jsPDF: {unit: 'in', format: 'a4', orientation: 'portrait'},
      };
      if (this.result) {
        html2pdf().set(opt).from(this.$refs.content.$el).save();
      }
    },


    async CopyToClip() {
      const text = this.userText + '\n\n' + this.aiText;
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand('copy');
          if (!successful) {
            throw new Error('复制失败');
          }
          console.log(this.Success);

          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
    },
    CreateByAI(forced) {
      if (this.aiText.length < 10) {
        this.Error('请先点击【获取数据】，否则没有数据支持无法生成');
        return;
      }
      if (this.aiText.length > 55000) {
        this.Error('文本内容过大(暂时只支持50000字以内的处理)，建议拆分处理');
        return;
      }
      this.ai_executings = true;
      const parser = 'chat';
      fetch(this.$api.defaults.baseURL+`/ai/parse/${parser}`, {
        method: 'POST',
        body: JSON.stringify({
          'content': this.cleaned,
          'stream': true,
          'cached_id': this.project_id + '_' + parser,
          'model': this.model,
          'forced': forced?1:0,
        }), headers: {
          ...this.$api.defaults.headers,
          'Content-Type': 'application/json',
        }}).then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          response.json().then((res) => {
            this.result = res.data;
            this.ai_executings = false;
            this.cached = true;
          }).catch((err) => {
            this.ai_executings = false;
          });
          return;
        }
        const that = this;
        const reader = response.body.getReader(); // 获取流读取器
        console.log(reader);
        const decoder = new TextDecoder(); // 创建解码器
        let result = '';
        const ReadStream = ()=>{
          reader.read().then(({done, value})=>{
            if (done) {
              console.log('done');
              this.ai_executings = false;
              return;
            }
            const decodedText = decoder.decode(value, {stream: true});
            console.log(decodedText);
            result += decodedText;
            this.result = result;
            this.moveAITextareaDown();
            ReadStream();
          });
        };


        ReadStream();
      })
          .catch((e) => {
            this.Error(e);
            this.ai_executings = false;
          });
    },
    moveAITextareaDown() {
      if (this.atd_timer) {
        return;
      }
      this.atd_timer = setTimeout(()=>{
        if (this.$refs.ai_input) {
          const inputElement = this.$refs.ai_input.$el.querySelector('textarea');
          this.$nextTick(()=>{
            inputElement.scrollTop = inputElement.scrollHeight;
          });
        }
        delete this.atd_timer;
      }, 500);
    },
    chat() {
      this.$ai.post('assistants/asst_7zEHmB2fxAgcP67FLe1M5R29/threads', {
        messages: [{role: 'user', content: '如何创建一个30层的直跑楼梯'}],
      }).then((res)=>{
        this.run = res.data.data;
        if (this.run.status !== 'complete') {
          setTimeout(()=>{
            this.Refresh();
          }, 1000);
        }
      });
    },
    RefreshSteps() {
      for (let i=0; i<this.steps.length; i++) {
        const step = this.steps[i];
        if (step.status == 'in_progress') {
          step.content = 'Answer:';
          this.RefreshStep(i);
        }
      }
    },
    RefreshStep(i) {
      const step = this.steps[i];
      this.$ai.get(`runs/${this.run.id}/steps/${step.id}?thread_id=${this.run.thread_id}`, {responseType: 'stream'}).then((response)=>{
        if (response && typeof response.pipe === 'function') {
          response.on('end', () => {
            console.log('end');
          });

          response.on('data', (chunk) => {
            console.log('data:', chunk.toString('utf-8'));
          });
        }
      });
    },
    RefreshMessage(message_id) {
      this.messages[message_id] = {content: ''};
      this.$ai.get(`threads/${this.run.thread_id}/message/${message_id}`, {responseType: 'stream', stream: true}).then((stream)=>{
        if (stream && stream.data) {
          stream.data.on('end', ()=>{
            console.log('end');
          });
          stream.data.on('data', (chunk)=>{
            this.messages[message_id].content += chunk.toString('utf-8');
            console.log('text:', chunk.toString('utf-8'));
          });
        }
      });
    },
    Refresh() {
      if (this.run && this.run.id) {
        this.$ai.get(`runs/${this.run.id}?thread_id=${this.run.thread_id}`).then((res)=>{
          const run = res.data.data;
          this.run.status = run.status;
          if (run.steps) {
            this.steps = run.steps;
          }
          if (this.run.status == 'queue') {
            setTimeout(()=>{
              this.Refresh();
            }, 1000);
          } else if (this.run.status == 'in_progress') {
            this.RefreshSteps();
          }
        });
      }
    },
  },
};
</script>

<style>
.image-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
  width: 200px;
  height: 170px;
}
.image-container img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-label{
  font-size: 12px;
  color: #666;
  text-align: center;
}

</style>
